export default __webpack_public_path__ + "static/media/410.7d50b1ab.svg";